module.exports = __webpack_public_path__ + "img/EXODONCIA_SIMPLE_INDICADA.png";